export default __webpack_public_path__ + "static/media/carro.b8fab487.png";